import { render, staticRenderFns } from "./consumableSurplusByStructure.vue?vue&type=template&id=e486979a&scoped=true"
import script from "./consumableSurplusByStructure.vue?vue&type=script&lang=js"
export * from "./consumableSurplusByStructure.vue?vue&type=script&lang=js"
import style0 from "./consumableSurplusByStructure.vue?vue&type=style&index=0&id=e486979a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e486979a",
  null
  
)

export default component.exports